import React from 'react';
import { translate } from 'react-i18next';

import UIStatusDialog from 'components/UIStatusDialog';

class ContactInfo extends React.Component {
  constructor(props) {
    super(props);

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handlePhoneBlur = this.handlePhoneBlur.bind(this);
    this.handleSave = this.handleSave.bind(this);

    this.state = {
      id: '',
      company_id: '',
      employee_id: '',
      email: '',
      role: '',
      uid: '',
      phone_country_code: '',
      phone_number: '',
      allow_account_edit: true,
      auth_provider: "",
      validated_email: {
        value: '',
        valid: '',
        inputClass: '',
      },
      validated_phone_number: {
        value: '',
        valid: '',
        inputClass: '',
      },
    };
  }

  componentWillReceiveProps(nextProps) {
    const coreUser = Utils.getCoreUser();
    let allow_account_edit = true;
    let account_provider = '';
    if (coreUser) {
      allow_account_edit = coreUser.allow_account_edit;
      account_provider   = coreUser.account_provider;
    }

    if (!Utils.isNotDefined(nextProps.user) || !Utils.isNotDefined(nextProps.user.employee_id)) {
      if (nextProps.hasOwnProperty('user') && nextProps.user.hasOwnProperty('id')) {
        let currentPhone;
        let phoneValid;
        phoneValid = this.validatePhoneNumber(nextProps.user.phone_number);
        currentPhone = nextProps.user.phone_number;

        const validatedEmail = nextProps.user.email;

        this.setState({
          phoneRequired: nextProps.validatePhone,
          id: nextProps.user.id,
          phone_number: nextProps.user.phone_number,
          phone_country_code: nextProps.user.phone_country_code,
          email: nextProps.user.email,
          company_id: nextProps.user.company_id,
          employee_id: nextProps.user.employee_id,
          role: nextProps.user.role,
          uid: nextProps.user.uid,
          allow_account_edit: allow_account_edit,
          account_provider: account_provider,
          validated_email: {
            value: validatedEmail,
            valid: this.validateEmail(validatedEmail),
            inputClass: '',
          },
          validated_phone_number: {
            value: currentPhone,
            valid: phoneValid,
            inputClass: phoneValid ? '' : 'error',
          },
        });
      }
    }
  }

  handleEmailChange(e) {
    const { value } = e.target;
    const valid = this.validateEmail(value);
    this.setState({
      validated_email: {
        value,
        valid,
        inputClass: valid ? 'valid' : 'error',
      },
      email: value,
      emailValidationMessage: valid ? '' : this.props.t('AccountInfo.email_invalid'),
    });
  }

  maskPhone(phone_number) {
    return phone_number.replace(/(\d{3})(\d{3})(\d{4})/, '($1)-$2-$3');
  }

  notifyOfMissingPhoneNumber() {
    this.setState({
      phoneValidationMessage:
        this.props.t('AccountInfo.phone_warning'),
    });
  }

  notifyOfInvalidPhoneNumber() {
    this.setState({
      phoneValidationMessage:
        this.props.t('AccountInfo.phone_invalid'),
    });
  }

  formDisabled() {
    let disabled = false;
    if (!this.state.validated_phone_number.valid) {
      disabled = true;
    }

    if (!this.state.validated_email.valid) {
      disabled = true;
    }

    if (!this.state.allow_account_edit) {
      disabled = true;
    }
    return disabled;
  }

  validateEmail(value) {
    let valid = false;
    const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (re.test(value)) {
      valid = true;
    }
    return valid;
  }

  unformattedPhoneNumber(formattedNumber) {
    if (_.isUndefined(formattedNumber)) return false;
    return formattedNumber.replace(/\D+/g, '');
  }

  validatePhoneNumber(value) {
    const appearsValid = /^\+?[1-9]\d{9,14}$/.test(value);
    const isBlank = value === null || value == '';
    if (this.props.validatePhone) {
      if (isBlank) {
        this.notifyOfMissingPhoneNumber();
        return false;
      }
      if (!appearsValid) this.notifyOfInvalidPhoneNumber();

      return appearsValid;
    }
    if (value === null || value == '') {
      return true;
    }
    this.notifyOfInvalidPhoneNumber();
    return appearsValid;
  }

  formatPhoneNumber(value) {
    let validatedNumber = '';
    if (value == '' || _.isEmpty(value)) {
      return validatedNumber;
    }

    const appearsValid = /^\+?[1-9]\d{9,14}$/.test(value);
    validatedNumber = value;
    if (appearsValid) {
      value = this.maskPhone(validatedNumber);
    }
    return validatedNumber;
  }

  handleChange(e) {
    const { value } = e.target;
    this.setState({ [e.target.name]: value });
    user[e.target.name] = value;
    let user = this.state;
    MakeShiftEmployeeDispatcher.dispatch({
      actionType: appConstants.ActionTypes.USER_CHANGED,
      postData: user,
    });
  }

  handlePhoneChange(e) {
    const { value } = e.target;
    const formattedPhoneNumber = this.formatPhoneNumber(value);

    this.setState({
      phoneValidationMessage: null,
      validated_phone_number: {
        value: formattedPhoneNumber,
        valid: this.validatePhoneNumber(formattedPhoneNumber),
      },
      phone_number: this.unformattedPhoneNumber(formattedPhoneNumber),
    });
  }

  handlePhoneBlur(e) {
    const { value } = e.target;
    const formattedPhoneNumber = this.formatPhoneNumber(value);

    const valid = this.validatePhoneNumber(formattedPhoneNumber);

    this.setState({
      validated_phone_number: {
        value: formattedPhoneNumber,
        valid,
        inputClass: valid ? 'valid' : 'error',
      },
      phone_number: this.unformattedPhoneNumber(formattedPhoneNumber),
    });
  }

  handleSave(e) {
    this.props.updateUser(this.state);
    e.preventDefault();
    MakeShiftEmployeeDispatcher.dispatch({
      actionType: appConstants.ActionTypes.UPDATE_USER,
      postData: this.state,
    });
  }

  render() {
    if (Utils.isNotDefined(this.props.user)) {
      // do not render yet, defaultValues will get set as null or blank data if the user object is not defined yet.
      // ... but employee ID is not required unless time and attendance is on, so we canna rely on that.
      return false;
    }

    const phoneValid = this.state.validated_phone_number.valid;
    const emailValid = this.state.validated_email.valid;
    const sanitizedPhoneNumber = _.isNull(this.state.phone_number)
      ? this.formatPhoneNumber(this.props.phone_number)
      : this.formatPhoneNumber(this.state.validated_phone_number.value);
    const optionsState = this.state.phone_country_code;
    let phoneInputClass = `field split ${this.state.validated_phone_number.inputClass}`;
    const emailInputClass = `field ${this.state.validated_email.inputClass}`;
    let phoneMessage = phoneValid ? '' : this.state.phoneValidationMessage;
    const emailMessage = emailValid ? '' : this.state.emailValidationMessage;
    let userName = this.props.user ? this.props.user.name : '';

    if (_.isUndefined(userName)) {
      userName = '';
    }

    if (!this.props.validatePhone) {
      phoneInputClass = 'field split';
      phoneMessage = '';
    }

    let readOnlyCopy;
    let partnerName = "";
    if (!this.state.allow_account_edit) {
      if (this.state.account_provider == 'bamboo') {
        partnerName = "BambooHR";
      } else if (this.state.account_provider == 'tsheets') {
        partnerName = "QuickBooks Time";
      } else if (this.state.account_provider == 'ADP') {
        partnerName = "ADP Workforce Now";
      }
      readOnlyCopy = (
        <div className="message">{this.props.t('AccountInfo.readonly_copy', { partnerName })}</div>
      );
    }

    const statusDialogs = [];
    for (let i = 0; i < this.props.statuses.length; i++) {
      statusDialogs.push(
        <UIStatusDialog
          status={this.props.statuses[i]}
          key={this.props.statuses[i].key}
          closeDialog={this.props.closeStatusDialog}
          closeDialogProps={this.state}
        />,
      );
    }

    return (
      <div className={this.props.activeState}>
        <form className="contact-info" onSubmit={this.handleSave}>
          <fieldset>
            <legend>
              <h1>{this.props.t('AccountInfo.contact_info')}</h1>
              {readOnlyCopy}
            </legend>
            <div className="field">
              <label htmlFor="full-name">{this.props.t('AccountInfo.name')}</label>
              <input name="full-name" type="text" defaultValue={userName} readOnly />
              <div className="message">{this.props.t('AccountInfo.talk_to_your_manager')}</div>
            </div>

            <div className="field">
              <label htmlFor="employee_id">{this.props.t('AccountInfo.employee_id')}</label>
              <input
                name="employee_id"
                type="text"
                defaultValue={this.props.user.employee_id || ''}
                readOnly
              />
            </div>

            {this.props.user.badge_id && (
              <div className="field">
                <label htmlFor="badge_id">{this.props.t('AccountInfo.badge_id')}</label>
                <input
                  name="badge_id"
                  type="text"
                  defaultValue={this.props.user.badge_id || ''}
                  readOnly
                />
              </div>
            )}

            <div className={emailInputClass}>
              <label htmlFor="email">{this.props.t('AccountInfo.email')}</label>
              <input
                name="email"
                type="email"
                value={this.state.email}
                onChange={this.handleEmailChange}
                readOnly={!this.state.allow_account_edit}
              />
              <div className="message">{emailMessage}</div>
            </div>

            <div className={phoneInputClass}>
              <div className="formColumn">
                <label htmlFor="phone_number">{this.props.t('AccountInfo.country_code')}</label>
                <div className="styledSelect">
                  <select
                    onChange={this.handleCountryCodeChange}
                    name="country_code"
                    disabled={!this.state.allow_account_edit}
                    value={optionsState}
                  >
                    <option value="1">{this.props.t('AccountInfo.north_america')}</option>
                  </select>
                </div>
              </div>
              <div className="formColumn last">
                <label htmlFor="phone_number">{this.props.t('AccountInfo.phone')}</label>
                <input
                  name="phone_number"
                  className="smallerField"
                  maxLength="14"
                  type="tel"
                  value={sanitizedPhoneNumber}
                  onChange={this.handlePhoneChange}
                  readOnly={!this.state.allow_account_edit}
                />
              </div>
              <div className="message">{phoneMessage}</div>
            </div>

            {this.state.allow_account_edit && (
              <div className="field">
                <input
                    name="save"
                    disabled={this.formDisabled()}
                    type="submit"
                    value={this.props.t('AccountInfo.save_changes')}
                  />
              </div>
            )}
          </fieldset>
        </form>
        {statusDialogs}
      </div>
    );
  }
}

export default translate()(ContactInfo);
